module.exports = __webpack_public_path__ + "static/media/cj-sheeran.36b32c04.png";